/* eslint-disable max-len */
import React from 'react';

const SquareLink = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_9538_24812)">
      <path
        d="M10.833 9.16406L18.333 1.66406M18.333 1.66406H13.8799M18.333 1.66406V6.11719"
        stroke={props.color ?? props?.style?.color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3337 9.9974C18.3337 13.9258 18.3337 15.89 17.1133 17.1103C15.8929 18.3307 13.9287 18.3307 10.0003 18.3307C6.07195 18.3307 4.10777 18.3307 2.88738 17.1103C1.66699 15.89 1.66699 13.9258 1.66699 9.9974C1.66699 6.06902 1.66699 4.10484 2.88738 2.88445C4.10777 1.66406 6.07195 1.66406 10.0003 1.66406"
        stroke={props.color ?? props?.style?.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9538_24812">
        <rect width="20" height="20" rx="4.16667" />
      </clipPath>
    </defs>
  </svg>
);

export default SquareLink;
